









































































































import { Vue, Prop, Component } from "vue-property-decorator";
import { CourseLectureProgress as ICourseLectureProgress } from "@/api/models/course-lecture-progress";
import ListenerTestPassProgress from "@/components/learning-progress/ListenerTestPassProgress.vue";
import { CourseTestPassProgress as ICourseTestPassProgress } from "@/api/models/course-test-pass-progress";

@Component({
  components: { ListenerTestPassProgress }
})
export default class ListenerLectureProgress extends Vue {
  @Prop() lectureProgress!: ICourseLectureProgress;
  @Prop() courseId!: string;
  @Prop() index?: number;
  @Prop() testPass?: ICourseTestPassProgress;

  get sortedPassesByPassedAt() {
    let sorted = this.lectureProgress.test?.pass;

    sorted?.sort(
      (a, b) => new Date(b.passedAt).getTime() - new Date(a.passedAt).getTime()
    );
    return sorted ? sorted[0] : undefined;
  }

  get testPassResult() {
    let status: string = "";

    if (
      this.sortedPassesByPassedAt?.passedAt &&
      this.sortedPassesByPassedAt?.success === false
    )
      status = this.$tc(this.$translate.TestFailed);
    if (
      this.sortedPassesByPassedAt?.passedAt &&
      this.sortedPassesByPassedAt?.success === true
    )
      status = this.$tc(this.$translate.TestSuccessfullyPassed);
    return status;
  }

  goToTestPass() {
    if (this.sortedPassesByPassedAt?.id) {
      let routeData = this.$router.resolve({
        name: "TestPassResultView",
        params: { testPassId: this.sortedPassesByPassedAt?.id }
      });
      window.open(routeData.href, "_blank");
    }
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get testPassesNull() {
    return this.lectureProgress.test?.pass.length === 0;
  }

  goToLecture() {
    this.$router.push({
      name: "lectureView",
      params: {
        courseId: this.courseId,
        courseLectureId: this.lectureProgress.id
      }
    });
  }
}
